<template>
    <div>
      <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
          <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
      </div>
      <div v-else>
        <v-row>
          <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
            <div class="title_page ma-3">
              <h4 class="breadcrumb_title_page">ยอดหนี้ของฉัน</h4>
              <v-breadcrumbs :items="sub_menu">
                <template v-slot:divider>
                  <v-icon>mdi-chevron-right</v-icon>
                </template>
              </v-breadcrumbs>
            </div>
          </v-col>
        </v-row>
  
        <v-row>
            <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
                 <v-card class="mx-auto input-radius bg-red"  >
                    <v-list-item three-line class="py-3" v-if="bill_need_pay != null ">
                        <v-list-item-content>
                            <v-row>
                                <v-col cols="12" lg="6">
                                    <div class="bold mb-4 text-white font-18 font-bold ">
                                        ยอดเงินที่ต้องชำระเดือนนี้
                                    </div>
                                </v-col>
                                <v-col cols="12" lg="6" class="text-right">
                                    <v-btn @click="link('/arin/pos/posdebtbalancepay?id='+bill_need_pay.id)" elevation="2" outlined text text-white class="input-radius btn-red-icon"  >
                                        <v-icon>mdi-wallet</v-icon>  ชำระเงิน
                                    </v-btn>
                                </v-col>
                            </v-row>
                          
                           
                            <v-list-item-title class="text-center mb-1 text-white font-bold-36">
                                {{formatPrice(bill_need_pay.total)}} <span class="font-18 font-bold"> บาท </span>
                            </v-list-item-title>
                            <v-list-item-subtitle class="text-center font-18 font-bold text-white">วันครบกำหนด {{bill_need_pay.due_date}}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item three-line class="py-3" v-else>
                        <v-list-item-content>
                            <v-row>
                                <v-col cols="12" lg="6">
                                    <div class="bold mb-4 text-white font-18 font-bold ">
                                        ยอดเงินที่ต้องชำระเดือนนี้
                                    </div>
                                </v-col>
                                <v-col cols="12" lg="6" class="text-right">
                                    <!-- <v-btn @click="link('/arin/pos/posdebtbalancepay?date='+bill_need_pay.start_date)" elevation="2" outlined text text-white class="input-radius btn-red-icon"  >
                                        <v-icon>mdi-wallet</v-icon>  ชำระเงิน
                                    </v-btn> -->
                                </v-col>
                            </v-row>
                          
                           
                            <v-list-item-title class="text-center mb-1 text-white font-bold-36">
                                {{formatPrice(0)}} <span class="font-18 font-bold"> บาท </span>
                            </v-list-item-title>
                            <v-list-item-subtitle class="text-center font-18 font-bold text-white">วันครบกำหนด ----------</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>

                    <!-- <v-card-actions>
                    
                    </v-card-actions> -->
                </v-card>
            </v-col>
            <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
                <v-card class="mx-auto input-radius"  >
                    <v-list-item three-line class="py-4">
                        <v-list-item-content class="progress-bar">
                            <div class="mb-4 font-18 font-bold">
                                เครดิตที่ใช้ได้คงเหลือ <span class="color-green"> {{formatPrice(customer.credit_remain)}} </span> บาท
                            </div>
                            <v-list-item-title class="text-h5 mb-1 mt-7">
                                <v-progress-linear class="input-radius " color="red lighten-1" :buffer-value="percent" stream height="15"></v-progress-linear>
                                <!-- <div class="number">72.00</div> -->
                            </v-list-item-title>
                            <v-list-item-subtitle class="text-right mt-2">เครดิตรวม <span class="font-18 font-bold"> {{formatPrice(customer.credit)}} </span></v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>

                    <!-- <v-card-actions>
                    <v-btn
                        outlined
                        rounded
                        text
                    >
                        Button
                    </v-btn>
                    </v-card-actions> -->
                </v-card>
            </v-col>
            <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                <v-card class="input-radius">
                <v-card-title>รายการดำเนินการ</v-card-title>
                    <v-card-text>
                        <v-expansion-panels elevation="4" v-model="panel" :disabled="disabled">
                          <v-expansion-panel class="rounded-xl my-1" >
                              <v-expansion-panel-header>
                                <v-row>
                                    <v-col xs="12" sm="12" md="1" lg="1" xl="1" cols="12" class="d-flex" style="align-items:center;">
                                        <div class=""> <v-img width="50" :lazy-src="refund" :src="refund"></v-img> </div>
                                    </v-col>
                                    <v-col class="d-flex" style="align-items:center;">
                                        <div style="font-weight: 500;font-size: 16px;color: #616A6B;">ประวัติการชำระเงิน</div>
                                    </v-col>
                                </v-row>
                              </v-expansion-panel-header>
                              <v-expansion-panel-content>
                                <v-row>
                                    <v-col cols="12">
                                      <v-simple-table>
                                        <template v-slot:default>
                                          <thead>
                                            <tr>
                                              <th class="text-left" width="25%">
                                                รอบบิลปัจจุบัน
                                              </th>
                                              <th class="text-left" width="25%">
                                                วันครบกำหนด
                                              </th>
                                              <th class="text-left"  width="25%">
                                                ยอดเงิน
                                              </th>
                                              <th class="text-left" width="25%">
                                                ดูรายละเอียด
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr  v-for="item in data_list" :key="item.name" >
                                              <td>{{ item.date_month }}</td>
                                              <td>{{ item.due_date }}</td>
                                              <td>{{ item.total == null ? '0.00' : formatPrice(item.total) }}</td>
                                              <td>
                                                <v-btn elevation="4" class="ma-3 font-16" outlined color="#8EBBDC" title="ดูรายละเอียด"
                                                  style="border-radius:10px" @click="$router.push({path:'/arin/pos/posdebtbalancepayhistory', query:{start_date: item.start_date}})" >
                                                  <v-icon>mdi-magnify</v-icon> ดูรายละเอียด
                                                </v-btn>  
                                              </td>
                                            </tr>
                                          </tbody>
                                        </template>
                                      </v-simple-table>
                                    </v-col>
                                </v-row>
                              </v-expansion-panel-content>
                          </v-expansion-panel>

                          <v-expansion-panel class="rounded-xl my-1" >
                              <v-expansion-panel-header>
                                <v-row>
                                    <v-col xs="12" sm="12" md="1" lg="1" xl="1" cols="12" class="d-flex" style="align-items:center;">
                                        <div class=""> <v-img width="50" :lazy-src="bill_v2" :src="bill_v2"></v-img> </div>
                                    </v-col>
                                    <v-col class="d-flex" style="align-items:center;">
                                        <div style="font-weight: 500;font-size: 16px;color: #616A6B;">รายการล่าสุด</div>
                                    </v-col>
                                </v-row>
                              </v-expansion-panel-header>

                              <v-expansion-panel-content>
                                <v-row>
                                    <v-col cols="12" v-for="item in list_late" :key="item.id">
                                       <h2>{{item.month}}</h2>
                                      <v-simple-table>
                                        <template v-slot:default>
                                          <thead>
                                            <tr> 
                                              <th class="text-left" width="20%">
                                                วันที่สั่งซื้อ
                                              </th>
                                              <th class="text-left"  width="20%">
                                                ยอดเงิน
                                              </th>
                                              <th class="text-left" width="20%">
                                                ดูรายละเอียด
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr  v-for="sub in item.oldList" :key="sub">
                                              <td>{{ sub.date }}</td>
                                              <td>{{ sub.total == null ? '0.00' :  formatPrice(sub.total)}}</td>
                                              <td>
                                                <v-btn elevation="4" class="ma-3 font-16" outlined color="#8EBBDC" title="ดูรายละเอียด"
                                                  style="border-radius:10px" @click="$router.push({path:'/arin/pos/posdebtbalancedetail', query:{id: sub.id}})" >
                                                  <v-icon>mdi-magnify</v-icon> ดูรายละเอียด
                                                </v-btn>  
                                              </td>
                                            </tr>
                                          </tbody>
                                        </template>
                                      </v-simple-table>
                                    </v-col>
                                </v-row>
                              </v-expansion-panel-content>
                          </v-expansion-panel>

                        </v-expansion-panels>
                    </v-card-text>
                </v-card>
                <v-dialog v-model="dialog_cancel_order" persistent max-width="375">
                    <v-card>
                        <div class="d-flex justify-space-between">
                            <v-card-title>
                                <b>ยกเลิกคำสั่งซื้อ</b>
                            </v-card-title>
                            <v-btn icon class="ma-4" @click="dialog_cancel_order = false">
                                <v-icon color="grey">mdi-close</v-icon>
                            </v-btn>
                        </div>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" class="text-center">
                                <v-img height="80" max-width="80" :lazy-src="img_cancel_order"
                                    :src="img_cancel_order" class="preview mt-3 mb-2"></v-img>
                                    <h3>คุณต้องการยกเลิกคำสั่งซื้อหรือไม่ ?</h3>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn   v-btn type="button" class="btn_add_data" elevation="4" large>ยืนยัน</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-col>
        </v-row>
      </div>
    </div>
  </template>
  
  <script>
  import cancel_order from "@/assets/arin_assets/cancel_order.png";
  import refund from "@/assets/arin_assets/refund.png";
  import bill_v2 from "@/assets/arin_assets/bill_v2.png";
   import { HTTP_ARIN } from "@/axios_arin";
   import { formatPrice } from "@/js/handler";
  
  export default {
    inject: {
      theme: {
        default: {
          isDark: false,
        },
      },
    },
    name: "Pos_debt_balance_list",
    data() {
      return {
        img_cancel_order: cancel_order,
        refund: refund,
        bill_v2: bill_v2,
        dialog_cancel_order: false,
        loading_page: true,
        panel: -1,
        disabled: false,
        footer_Props: {
          // showFirstLastPage: true,
          // firstIcon: 'mdi-arrow-collapse-left',
          // lastIcon: 'mdi-arrow-collapse-right',
          // prevIcon: 'mdi-minus',
          // nextIcon: 'mdi-plus',
          'items-per-page-text': 'รายการต่อหน้า'
        },
        sub_menu: [
          {
            text: 'ระบบ POS',
            disabled: false,
          },
          {
            text: 'ออกใบสั่งซื้อ',
            disabled: false,
          },
          {
            text: 'ยอดหนี้ของฉัน',
            disabled: false,
            href: '#',
          },
        ],
        data_list: [
          {
            id: 1,
            bill_now: 'ธันวาคม 2022',
            due_date: '16/12/2022',
            balance: 35.00 + ' บาท',
          },
          {
            id: 2,
            bill_now: 'ธันวาคม 2022',
            due_date: '17/12/2022',
            balance: 100.00 + ' บาท',
          },
        ],
        list_late: [
          {
            id: 1,
            order_date: '01/12/2022',
            bill_now: 'ธันวาคม 2022',
            due_date: '16/12/2022',
            balance: 35.00 + ' บาท',
          },
          {
            id: 2,
            order_date: '01/12/2022',
            bill_now: 'ธันวาคม 2022',
            due_date: '17/12/2022',
            balance: 100.00 + ' บาท',
          },
        ],
        customer: {},
        current_bills: [],
        bill_need_pay: {},
        percent: 0,
      }
    },
    methods: {
      formatPrice(number){
        return formatPrice(number)
      },
      link(link) {
        window.location.href = link;
      },
      cancel_order() {
        this.dialog_cancel_order = true;
      },
       getList(){
        const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
        HTTP_ARIN.get('/credit', config).then((res) => {
            if (res.data.successful === true) {
            this.data_list = res.data.old_order
            this.list_late = res.data.last_order
            this.customer =res.data.customer
            this.percent = parseFloat(this.customer.credit_remain) / parseFloat(this.customer.credit) * 100
            // this.current_bills =res.data.current_bills
            this.bill_need_pay =res.data.bill_need_pay ? res.data.bill_need_pay : null
            this.loading_page = false;
            }
        })
        
       },
    },
    mounted(){
      this.getList()
    }
  }
  </script>
  
  <style scoped>
  /* .progress-bar {
  position: relative;
  height: 20px;
  width: 100%;
} */

.line {
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.number {
  position: absolute;
  top: -20px;
  right: 0;
  z-index: 2;
}

    .color-green
    {
        color: #88B358;
    }

    .font-bold-36 {
        font-size: 36px;
        font-weight: bold; 
    }
    
    .text-white {
       color: #FFF !important;
    }

    .font-16 {
        font-size: 16px;
    }
    .font-18 {
        font-size: 18px;
    }

    .font-bold {
        font-weight: bold;
    }
    .input-radius {
        border-radius: 10px;
    }

    .btn-red-icon {
        color: #EC6162;
        background-color: white;
        font-size: 14px;
        font-weight: bold;
    }

    .bg-red {
        background-color: #EC6162
    }

    .header_title {
        font-weight: 600;
        font-size: 20px;
        color: #616A6B;
    }
    
    .font_mobile {
        font-size: 14px !important;
    }
    
    .grid_three {
        display: flex;
        justify-content: space-between;
    }
    
    .tag_arin_magnify {
        border: 1px solid #FEA06C;
        color: #FEA06C;
        font-weight: 500;
        font-size: 16px;
        border-radius: 10px;
        background-color: #FFFFFF;
    }
    
    .preview {
        border-radius: 10px;
        margin: auto;
    }
    
    .btn_add_data {
        font-size: 16px;
        color: #FFF;
        background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
        border-radius: 10px;
        width: 50%;
    }
    
    .btn_add_data_submit {
        font-size: 16px;
        color: #FFF;
        /* background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important; */
        border-radius: 10px;
        width: 15%;
    }
  
  @media only screen and (min-width: 0px)AND (max-width: 361px) {
    .btn_add_data {
      font-size: 16px;
      color: #FFF;
      background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
      border-radius: 10px;
      width: 100%;
    }
  
    .btn_add_data_submit {
      font-size: 16px;
      color: #FFF;
      border-radius: 10px;
      width: 100%;
    }
  }
  
  @media only screen and (max-width: 600px) {
    .btn_add_data {
      font-size: 16px;
      color: #FFF;
      background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
      border-radius: 10px;
      width: 100%;
    }
  
    .btn_add_data_submit {
      font-size: 16px;
      color: #FFF;
      border-radius: 10px;
      width: 50%;
    }
  }
  
  @media only screen and (min-width: 601px) AND (max-width: 960px) {
    .btn_add_data {
      font-size: 16px;
      color: #FFF;
      background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
      border-radius: 10px;
      width: 50%;
    }
  
    .btn_add_data_submit {
      font-size: 16px;
      color: #FFF;
      border-radius: 10px;
      width: 50%;
    }
  }
  
  @media only screen and (min-width: 961px) AND (max-width: 1264px) {
    .btn_add_data {
      font-size: 16px;
      color: #FFF;
      background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
      border-radius: 10px;
      width: 50%;
    }
  
    .btn_add_data_submit {
      font-size: 16px;
      color: #FFF;
      border-radius: 10px;
      width: 50%;
    }
  }
  
  @media only screen and (min-width: 1265px) AND (max-width: 1904px) {
    .btn_add_data {
      font-size: 16px;
      color: #FFF;
      background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
      border-radius: 10px;
      width: 25%;
    }
  
    .btn_add_data_submit {
      font-size: 16px;
      color: #FFF;
      border-radius: 10px;
      width: 25%;
    }
  }
  
  </style>
  